<template>
    <card-form
            class="card-form_max-xs"
            :validator="$validator"
            :model.sync="model"
            label-create="msg.createProject"
            label-edit="msg.editProject"
            route-edit="edit_project"
            action-load="loadProject"
            action-create="createProject"
            action-edit="editProject"
            success-route="projects"
            @loaded="modelLoaded($event)"
            :form-errors="errors"
            :before-submit="beforeSubmit"
    >
        <v-card
                class="mt-4"
        >
            <v-card-text
                    :class="{
                        'c-pa-10': $vuetify.breakpoint.xsOnly
                    }"
            >
                <v-text-field
                        :label="$t('msg.name')"
                        v-model="model.name"
                        :error-messages="errors.collect('name')"
                        data-vv-name="name"
                        v-validate="'required|max:255'"
                        :dense="!isMobile"
                        outlined
                        hide-details="auto"
                        class="card-form__input"
                ></v-text-field>
                <v-textarea
                        :label="$t('msg.description')"
                        v-model="model.desc"
                        :error-messages="errors.collect('desc')"
                        data-vv-name="desc"
                        :dense="!isMobile"
                        outlined
                        hide-details="auto"
                        class="card-form__input"
                ></v-textarea>
                <v-combobox
                        v-model="model.tag"
                        :label="$t('msg.markers')"
                        :error-messages="errors.collect('tags')"
                        data-vv-name="tags"
                        multiple
                        small-chips
                        hide-selected
                        clearable
                        deletable-chips
                        :dense="!isMobile"
                        outlined
                        hide-details="auto"
                        class="card-form__input"
                ></v-combobox>
                <twin-dates v-if="false" class="mt-3">
                    <template v-slot:left>
                        <date-input
                                v-model="model.start_at"
                                data-vv-name="start_at"
                                :error-messages="errors.collect('start_at')"
                                label="msg.dateStart"
                                :width="0"
                                ref="start_at"
                                clearable
                        ></date-input>
                    </template>
                    <template v-slot:right>
                        <date-input
                                v-model="model.end_at"
                                data-vv-name="end_at"
                                :error-messages="errors.collect('end_at')"
                                v-validate="'date_order:start_at'"
                                label="msg.dateEnd"
                                :width="0"
                                clearable
                        ></date-input>
                    </template>
                </twin-dates>
                <input-color
                        v-model="model.color"
                        class="mt-3"
                ></input-color>
                <v-switch
                    v-if="model.id !== null"
                    v-model="model.is_done"
                    dense
                    hide-details="auto"
                    :label="$t('msg.isDone')"
                    class="card-form__input"
                ></v-switch>
                <v-switch
                    v-if="model.id !== null"
                    v-model="model.is_archive"
                    dense
                    hide-details="auto"
                    :label="$t('msg.isArchive')"
                    class="card-form__input"
                ></v-switch>
            </v-card-text>
        </v-card>
    </card-form>
</template>

<script>
    import TwinDates from '../../../components/ui/TwinDates';
    import DateInput from '../../../components/ui/Date';
    import InputColor from "../../../components/ui/InputColor";
    import {format} from 'date-fns';

    export default {
        components: {TwinDates, DateInput, InputColor},
        data() {
            return {
                id: null,
                formLoading: false,
                modelLoading: false,
                model: {
                    id: null,
                    name: null,
                    desc: null,
                    tag: [],
                    is_done: false,
                    is_archive: false,
                    start_at: null,
                    end_at: null,
                    color: null
                }
            }
        },
        methods: {
            modelLoaded(model) {

                let start = this.dateServerToLocal(model.start_at);
                let end = this.dateServerToLocal(model.end_at);

                model.start_at = start !== null ? format(start, 'yyyy-MM-dd') : null;
                model.end_at = end !== null ? format(end, 'yyyy-MM-dd') : null;

                this.$store.commit('setBreadcrumbs', [{id: 2, name: this.model.name}]);
            },
            beforeSubmit(model) {
                model.start_at = this.dateLocalToServer(model.start_at);
                model.end_at = this.dateLocalToServer(model.end_at);
            }
        }
    }
</script>